import * as React from 'react';
import { cloneElement, isValidElement, ReactElement, ReactNode } from 'react';
import { useTranslate } from 'react-admin';
import { ListSubheader, styled } from '@mui/material';

import { SearchPanelProps } from './types';
import { SearchResultItem } from './SearchResultItem';

/**
 * A component which displays search results for a specific target.
 *
 * @param props {SearchResultsGroupProps}
 * @param props.data {SearchResultDataItem[]} The search results
 * @param props.label {ReactElement|string} The target label
 * @param props.onClose {Function} The function to call when the Search PopOver should be closed.
 */
export const SearchResultsGroup = (
    props: SearchResultsGroupProps
): ReactElement => {
    const { children = defaultChildren, data, label, onClose } = props;
    const translate = useTranslate();

    return (
        <>
            <Root component="h5" role="presentation">
                {isValidElement(label)
                    ? label
                    : translate(label.toString(), { _: label })}
            </Root>
            {data.map(searchResultItem =>
                cloneElement(children, {
                    key: searchResultItem.id,
                    data: searchResultItem,
                    onClose,
                })
            )}
        </>
    );
};

const Root = styled(ListSubheader)(({ theme }) => ({
    lineHeight: theme.spacing(4),
    backgroundColor: 'inherit',
    marginBottom: 1,
    marginTop: 1,
})) as typeof ListSubheader;

const defaultChildren = <SearchResultItem />;

interface SearchResultsGroupProps extends SearchPanelProps {
    children?: ReactElement;
    label?: string | ReactNode;
}
